var map = {
	"./b0_author.mp3": 811,
	"./b0_author_woah.mp3": 812,
	"./b0_p10_clickable.mp3": 813,
	"./b0_p10_clickable_b.mp3": 814,
	"./b0_p10_clickable_c.mp3": 815,
	"./b0_p11_boomer.mp3": 816,
	"./b0_p11_clickable.mp3": 817,
	"./b0_p11_clickable_b.mp3": 818,
	"./b0_p11_clickable_c.mp3": 819,
	"./b0_p11_clickable_d.mp3": 820,
	"./b0_p11_crystal.mp3": 821,
	"./b0_p11_melody.mp3": 822,
	"./b0_p11_narration.mp3": 823,
	"./b0_p11_narration_b.mp3": 824,
	"./b0_p11_scout.mp3": 825,
	"./b0_p11_scout_01.mp3": 826,
	"./b0_p12_clickable.mp3": 827,
	"./b0_p13_boomer.mp3": 828,
	"./b0_p13_clickable.mp3": 829,
	"./b0_p13_crystal.mp3": 830,
	"./b0_p13_melody.mp3": 831,
	"./b0_p13_narration_b.mp3": 832,
	"./b0_p13_scout.mp3": 833,
	"./b0_p14_clickable.mp3": 834,
	"./b0_p15_boomer.mp3": 835,
	"./b0_p15_clickable.mp3": 836,
	"./b0_p15_clickable_b.mp3": 837,
	"./b0_p15_crystal.mp3": 838,
	"./b0_p15_melody.mp3": 839,
	"./b0_p15_narration_b.mp3": 840,
	"./b0_p15_scout.mp3": 841,
	"./b0_p16_clickable.mp3": 842,
	"./b0_p1_boomer.mp3": 843,
	"./b0_p1_clickable.mp3": 844,
	"./b0_p1_clickable_b.mp3": 845,
	"./b0_p1_crystal.mp3": 846,
	"./b0_p1_melody.mp3": 847,
	"./b0_p1_narration_b.mp3": 848,
	"./b0_p1_scout.mp3": 849,
	"./b0_p2_clickable.mp3": 850,
	"./b0_p2_clickable_b.mp3": 851,
	"./b0_p3_boomer.mp3": 852,
	"./b0_p3_clickable.mp3": 853,
	"./b0_p3_crystal.mp3": 854,
	"./b0_p3_melody.mp3": 855,
	"./b0_p3_narration.mp3": 856,
	"./b0_p3_narration_b.mp3": 857,
	"./b0_p3_scout.mp3": 858,
	"./b0_p4_clickable.mp3": 859,
	"./b0_p5_boomer.mp3": 860,
	"./b0_p5_clickable.mp3": 861,
	"./b0_p5_crystal.mp3": 862,
	"./b0_p5_melody.mp3": 863,
	"./b0_p5_narration.mp3": 864,
	"./b0_p5_narration_b.mp3": 865,
	"./b0_p5_scout.mp3": 866,
	"./b0_p6_clickable.mp3": 867,
	"./b0_p6_clickable_b.mp3": 868,
	"./b0_p7_boomer.mp3": 869,
	"./b0_p7_clickable.mp3": 870,
	"./b0_p7_crystal.mp3": 871,
	"./b0_p7_melody.mp3": 872,
	"./b0_p7_narration.mp3": 873,
	"./b0_p7_narration_b.mp3": 874,
	"./b0_p7_scout.mp3": 875,
	"./b0_p8_clickable.mp3": 876,
	"./b0_p8_clickable_b.mp3": 877,
	"./b0_p9_boomer.mp3": 878,
	"./b0_p9_clickable.mp3": 879,
	"./b0_p9_crystal.mp3": 880,
	"./b0_p9_melody.mp3": 881,
	"./b0_p9_narration.mp3": 882,
	"./b0_p9_narration_b.mp3": 883,
	"./b0_p9_scout.mp3": 884
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 810;